import React from 'react';
import { Button, Flex } from '@/components/ui';
import { IconEye, IconTrash } from '@tabler/icons-react';
import { SelectedFile } from './types';

interface FileActionsProps {
  file: SelectedFile;
  onPreview: (file: SelectedFile) => void;
  onRemove: (file: SelectedFile) => void;
}

export const FileActions: React.FC<FileActionsProps> = ({
  file,
  onPreview,
  onRemove,
}) => {
  return (
    <Flex gap="1" align="center">
      {/* Preview button */}
      <Button
        variant="text"
        size="small"
        isIconOnly
        onClick={() => onPreview(file)}
        startIcon={<IconEye />}
        title="Preview file"
      />

      {/* Remove button */}
      <Button
        variant="text"
        size="small"
        color="error"
        isIconOnly
        onClick={() => onRemove(file)}
        startIcon={<IconTrash />}
        title="Remove file"
      />
    </Flex>
  );
};

export default FileActions;
